"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ContactFormImpl_1 = require("../impl/ContactFormImpl");
class ContactForm extends ContactFormImpl_1.default {
    onEnquirySubmit(event) {
        super.onEnquirySubmit(event);
        alert('Enquiry has been sent');
    }
    render() {
        return (React.createElement("form", { onSubmit: this.onEnquirySubmit },
            React.createElement("div", { className: 'form-item' },
                React.createElement("span", { className: 'wpcf7-form-control-wrap your-name' },
                    React.createElement("input", { className: 'form-control', placeholder: 'Your name*', type: 'text', required: true, minLength: 3, onChange: this.nameChange, value: this.state.name }))),
            React.createElement("div", { className: 'form-item' },
                React.createElement("span", { className: 'wpcf7-form-control-wrap your-email' },
                    React.createElement("input", { className: 'form-control', type: 'email', placeholder: 'Your Email*', required: true, onChange: this.emailChange, value: this.state.email }))),
            React.createElement("div", { className: 'form-textarea' },
                React.createElement("textarea", { className: 'form-control', rows: 3, required: true, minLength: 3, placeholder: 'Leave us a message...', onChange: this.commentChange, value: this.state.message })),
            React.createElement("div", { className: 'form-actions' },
                React.createElement("input", { type: 'submit', className: 'wpcf7-form-control wpcf7-submit', defaultValue: 'Send' }))));
    }
}
exports.default = ContactForm;
